module.exports = __webpack_public_path__ + "img/audio-bg.1545514b.png";